/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-label-unit',
  templateUrl: './label-unit.component.html',
  styleUrls: ['./label-unit.component.scss'],
})
export class LabelUnitComponent implements OnInit {
  constructor(
    private router: Router,
    private appService: AppService,
  ) {}

  ngOnInit() {}

  /**卡片数据 */
  @Input() item: any | null = null;

  /**宽高比 */
  @Input() ratio: number = 1 / 0.4;

  @Output() clickItem: EventEmitter<any> = new EventEmitter();

  onClickItem() {
    if (!this.item) return;
    const item = this.item;
    if (item.configUrl) {
      this.router.navigateByUrl(`${this.appService.languageCode}/${item.configUrl}`);
    } else {
      this.router.navigateByUrl(`${this.appService.languageCode}/casino/category/${item.labelCode}`);
    }
    this.clickItem.emit(item);
  }
}
